import { Block } from "common/types/graphql"
import { BlocksRenderer } from "../BlocksRenderer"
import clsx from "classnames"

export interface ParagraphProps {
  blocks?: Block[]
  text?: string
}

export const Paragraph = ({ blocks, text }: ParagraphProps) => {
  const hasBlocks = blocks && blocks.length > 0
  const hasText = text && text.length > 0
  return (
    <p
      className={clsx("max-w-screen-lg font-serif lg:text-xl", {
        "mb-4": hasBlocks || hasText,
      })}
    >
      {blocks && <BlocksRenderer blocks={blocks} />}
      {text}
    </p>
  )
}
